import React from 'react';
import { Button } from '../components/ui/Button';
import { BotIcon, ZapIcon, BarChart2Icon, UsersIcon, ShieldIcon, CheckIcon, MessageSquareIcon, ShoppingCartIcon, TrendingUpIcon } from 'lucide-react';
export function AgentterPage() {
  return <div className="w-full" data-id="element-232">
      {/* Hero Section */}
      <section className="bg-black text-white py-24 relative" data-id="element-233">
        <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-234">
          <img src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" alt="AI Technology" className="w-full h-full object-cover opacity-40" data-id="element-235" />
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-236">
          <div className="max-w-3xl" data-id="element-237">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-238">
              Agentter.ai
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8" data-id="element-239">
              Advanced AI-powered agents for commerce and operations,
              streamlining business processes and enhancing customer
              experiences.
            </p>
            <Button href="/contact" size="lg" data-id="element-240">
              Transform Your Business
            </Button>
          </div>
        </div>
      </section>
      {/* Overview Section */}
      <section className="py-16 md:py-24 bg-white" data-id="element-241">
        <div className="container mx-auto px-4" data-id="element-242">
          <div className="max-w-4xl mx-auto" data-id="element-243">
            <div className="flex justify-center mb-12" data-id="element-244">
              <BotIcon className="h-20 w-20 text-black" data-id="element-245" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-8 text-center" data-id="element-246">
              The Future of Business Automation
            </h2>
            <p className="text-lg text-gray-600 mb-8 text-center" data-id="element-247">
              Agentter.ai deploys intelligent AI agents that work 24/7 to
              automate routine tasks, enhance customer interactions, and provide
              valuable business insights. Our advanced technology helps
              businesses operate more efficiently while delivering exceptional
              customer experiences.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-248">
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-249">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-250">
                  <ZapIcon className="h-8 w-8 text-black" data-id="element-251" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-252">
                  Powerful AI
                </h3>
                <p className="text-gray-600" data-id="element-253">
                  State-of-the-art AI models that understand context, learn from
                  interactions, and make intelligent decisions.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-254">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-255">
                  <ShieldIcon className="h-8 w-8 text-black" data-id="element-256" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-257">
                  Enterprise-Grade
                </h3>
                <p className="text-gray-600" data-id="element-258">
                  Secure, scalable, and reliable infrastructure designed for
                  businesses of all sizes.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-259">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-260">
                  <BarChart2Icon className="h-8 w-8 text-black" data-id="element-261" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-262">
                  Data-Driven
                </h3>
                <p className="text-gray-600" data-id="element-263">
                  Advanced analytics and insights to help you understand
                  performance and optimize operations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Solutions Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-264">
        <div className="container mx-auto px-4" data-id="element-265">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-266">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-267">
              Our Solutions
            </h2>
            <p className="text-lg text-gray-600" data-id="element-268">
              Intelligent AI agents designed for specific business functions and
              industry needs.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-269">
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-270">
              <div className="mb-6" data-id="element-271">
                <MessageSquareIcon className="h-12 w-12 text-black" data-id="element-272" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-273">
                Customer Service AI Agents
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-274">
                24/7 customer support agents that handle inquiries, resolve
                issues, and provide personalized assistance across multiple
                channels.
              </p>
              <ul className="space-y-2" data-id="element-275">
                <li className="flex items-start" data-id="element-276">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-277" />
                  <span className="text-gray-600" data-id="element-278">
                    Multilingual support across channels
                  </span>
                </li>
                <li className="flex items-start" data-id="element-279">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-280" />
                  <span className="text-gray-600" data-id="element-281">
                    Contextual understanding of customer history
                  </span>
                </li>
                <li className="flex items-start" data-id="element-282">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-283" />
                  <span className="text-gray-600" data-id="element-284">
                    Seamless escalation to human agents when needed
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-285">
              <div className="mb-6" data-id="element-286">
                <TrendingUpIcon className="h-12 w-12 text-black" data-id="element-287" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-288">
                Sales & Marketing Automation
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-289">
                AI agents that qualify leads, nurture prospects, and optimize
                marketing campaigns to drive revenue growth.
              </p>
              <ul className="space-y-2" data-id="element-290">
                <li className="flex items-start" data-id="element-291">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-292" />
                  <span className="text-gray-600" data-id="element-293">
                    Intelligent lead qualification and scoring
                  </span>
                </li>
                <li className="flex items-start" data-id="element-294">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-295" />
                  <span className="text-gray-600" data-id="element-296">
                    Personalized outreach and follow-up
                  </span>
                </li>
                <li className="flex items-start" data-id="element-297">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-298" />
                  <span className="text-gray-600" data-id="element-299">
                    Campaign optimization and performance analysis
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-300">
              <div className="mb-6" data-id="element-301">
                <UsersIcon className="h-12 w-12 text-black" data-id="element-302" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-303">
                Operational Workflow Optimization
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-304">
                AI agents that streamline internal processes, automate routine
                tasks, and improve operational efficiency.
              </p>
              <ul className="space-y-2" data-id="element-305">
                <li className="flex items-start" data-id="element-306">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-307" />
                  <span className="text-gray-600" data-id="element-308">
                    Process automation and workflow management
                  </span>
                </li>
                <li className="flex items-start" data-id="element-309">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-310" />
                  <span className="text-gray-600" data-id="element-311">
                    Resource allocation and scheduling
                  </span>
                </li>
                <li className="flex items-start" data-id="element-312">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-313" />
                  <span className="text-gray-600" data-id="element-314">
                    Bottleneck identification and resolution
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-315">
              <div className="mb-6" data-id="element-316">
                <ShoppingCartIcon className="h-12 w-12 text-black" data-id="element-317" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-318">
                Personalized Shopping Assistants
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-319">
                AI shopping assistants that guide customers through their buying
                journey, providing personalized recommendations and support.
              </p>
              <ul className="space-y-2" data-id="element-320">
                <li className="flex items-start" data-id="element-321">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-322" />
                  <span className="text-gray-600" data-id="element-323">
                    Personalized product recommendations
                  </span>
                </li>
                <li className="flex items-start" data-id="element-324">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-325" />
                  <span className="text-gray-600" data-id="element-326">
                    Interactive shopping guidance
                  </span>
                </li>
                <li className="flex items-start" data-id="element-327">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-328" />
                  <span className="text-gray-600" data-id="element-329">
                    Post-purchase support and upselling
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Case Studies */}
      <section className="py-16 md:py-24 bg-white" data-id="element-330">
        <div className="container mx-auto px-4" data-id="element-331">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-332">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-333">
              Success Stories
            </h2>
            <p className="text-lg text-gray-600" data-id="element-334">
              See how businesses are transforming their operations and customer
              experiences with Agentter.ai.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-335">
            <div className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-336">
              <div className="h-64 bg-gray-200" data-id="element-337">
                <img src="https://images.unsplash.com/photo-1556740758-90de374c12ad?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="E-commerce Business" className="w-full h-full object-cover" data-id="element-338" />
              </div>
              <div className="p-8" data-id="element-339">
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-340">
                  Global E-commerce Retailer
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-341">
                  Implemented Agentter.ai's customer service and shopping
                  assistant agents to enhance the online shopping experience and
                  reduce support costs.
                </p>
                <p className="text-gray-600" data-id="element-342">
                  <strong data-id="element-343">Results:</strong> 65% reduction in customer service
                  costs, 40% increase in average order value, and 30%
                  improvement in customer satisfaction scores.
                </p>
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-344">
              <div className="h-64 bg-gray-200" data-id="element-345">
                <img src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Financial Services Company" className="w-full h-full object-cover" data-id="element-346" />
              </div>
              <div className="p-8" data-id="element-347">
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-348">
                  Financial Services Provider
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-349">
                  Deployed Agentter.ai's operational workflow and sales
                  automation agents to streamline internal processes and enhance
                  client acquisition.
                </p>
                <p className="text-gray-600" data-id="element-350">
                  <strong data-id="element-351">Results:</strong> 50% reduction in processing time for
                  client onboarding, 35% increase in lead conversion rates, and
                  25% improvement in operational efficiency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Integration Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-352">
        <div className="container mx-auto px-4" data-id="element-353">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-354">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-355">
              Seamless Integration
            </h2>
            <p className="text-lg text-gray-600" data-id="element-356">
              Agentter.ai integrates with your existing systems and workflows,
              providing a smooth implementation experience.
            </p>
          </div>
          <div className="bg-white p-8 md:p-12 rounded-lg shadow-sm max-w-5xl mx-auto" data-id="element-357">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-358">
              <div data-id="element-359">
                <h3 className="text-xl font-semibold text-black mb-4" data-id="element-360">
                  Easy Implementation
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-361">
                  Our team of experts guides you through the entire
                  implementation process, from initial setup to ongoing
                  optimization.
                </p>
                <ul className="space-y-3" data-id="element-362">
                  <li className="flex items-start" data-id="element-363">
                    <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-364" />
                    <span className="text-gray-600" data-id="element-365">
                      Quick deployment with minimal disruption
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-366">
                    <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-367" />
                    <span className="text-gray-600" data-id="element-368">
                      Customized implementation based on your needs
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-369">
                    <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-370" />
                    <span className="text-gray-600" data-id="element-371">
                      Comprehensive training and onboarding
                    </span>
                  </li>
                </ul>
              </div>
              <div data-id="element-372">
                <h3 className="text-xl font-semibold text-black mb-4" data-id="element-373">
                  Compatible Systems
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-374">
                  Agentter.ai integrates with a wide range of business systems
                  and platforms.
                </p>
                <ul className="space-y-3" data-id="element-375">
                  <li className="flex items-start" data-id="element-376">
                    <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-377" />
                    <span className="text-gray-600" data-id="element-378">
                      CRM systems (Salesforce, HubSpot, etc.)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-379">
                    <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-380" />
                    <span className="text-gray-600" data-id="element-381">
                      E-commerce platforms (Shopify, WooCommerce, etc.)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-382">
                    <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-383" />
                    <span className="text-gray-600" data-id="element-384">
                      Communication tools (Slack, Teams, etc.)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-385">
                    <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-386" />
                    <span className="text-gray-600" data-id="element-387">
                      Customer service platforms (Zendesk, Intercom, etc.)
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-black text-white" data-id="element-388">
        <div className="container mx-auto px-4 bg-pattern" data-id="element-389">
          <div className="max-w-4xl mx-auto text-center" data-id="element-390">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-391">
              Ready to Transform Your Business?
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-392">
              Join forward-thinking businesses that are leveraging AI agents to
              automate operations, enhance customer experiences, and drive
              growth.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-393">
              <Button href="/contact" size="lg" data-id="element-394">
                Schedule a Demo
              </Button>
              <Button href="/contact" variant="outline" size="lg" className="border-white text-white hover:bg-gray-900" data-id="element-395">
                Contact Sales
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
}